import { Controller } from '@hotwired/stimulus'
import { Confirmable } from 'mixins/confirmable'
class CareersController extends Confirmable(Controller) {
  connect () {
    this.initConfirmableForms([this.formTarget.id])
  }
}
CareersController.targets = ['form']
export default CareersController
